// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid[data-v-496cde2e]{gap:1rem}@media(min-width: 48em){.grid[data-v-496cde2e]{gap:1.5rem}}.show-more[data-v-496cde2e]{margin:2rem 0 0}a[data-v-496cde2e]{display:-webkit-inline-box;display:inline-flex;-webkit-box-pack:center;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
